import { render } from "./CropOrganicFertilization.vue?vue&type=template&id=da22d584&scoped=true&ts=true"
import script from "./CropOrganicFertilization.vue?vue&type=script&lang=ts"
export * from "./CropOrganicFertilization.vue?vue&type=script&lang=ts"

import "./CropOrganicFertilization.vue?vue&type=style&index=0&id=da22d584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da22d584"]])

export default __exports__